module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "clear": "both",
      "height": "70px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "left": "0px",
      "bottom": "0px",
      "width": "100%",
      "z-index": "-1"
    }
  }, [_c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__wrap"
  }, [_c('div', {
    staticClass: "footer__secondary"
  }, [_c('div', {
    staticClass: "footer__inner"
  }, [_c('div', {
    staticClass: "footer__secondary__nav"
  }, [_c('span', [_vm._v("  Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00ca0a92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 317
// module chunks = 2